module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-22.e9d75f3.woff2";